import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Taxi from "components/Taxi/Taxi.js";
export default function BCTaxi() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Báo cáo tháng xe Taxi",
            tabContent: <Taxi />,
          },
        ]}
      />
    </div>
  );
}
